module.exports = __webpack_public_path__ + "img/calendar-icon.84c5c550.svg";